// // import React, { useState, useEffect, useCallback, useRef } from "react";
// import axios from "axios";import { useCallback, useEffect, useRef, useState } from "react";
// import {
//   IoPencil,
//   IoTrashBin,
//   IoThumbsUp,
//   IoThumbsDown,
//   IoFlag,
// } from "react-icons/io5";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const CustomerClarificationBoard = ({ user, requestId }) => {
//   /* ─── STATE ────────────────────────────────────────── */
//   const [comments, setComments] = useState([]);
//   const [replyDrafts, setReplyDrafts] = useState({});
//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [editingReplyId, setEditingReplyId] = useState(null);
//   const [editingReplyText, setEditingReplyText] = useState("");
//   const [expandedComments, setExpandedComments] = useState({});
//   const submittingRef = useRef({});
//   const [submittingIds, setSubmittingIds] = useState({});

//   /* REPORT modal */
//   const [reportOpen, setReportOpen] = useState(false);
//   const [reportTarget, setReportTarget] = useState(null);
//   const [reasonType, setReasonType] = useState("");
//   const [customReason, setCustomReason] = useState("");
//   const [reportSubmitting, setReportSubmitting] = useState(false);

//   /* CONFIG / HELPERS */
//   const API_V2 = process.env.REACT_APP_SERVER_URL_V2;
//   const API_V1 = API_V2.replace("/api/v2", "/api/v1");
//   const accessToken = localStorage.getItem("accessToken");

//   const buildProfileUrl = (uid, pid) =>
//     uid && pid ? `${API_V1}/photos/${uid}/images/${pid}` : null;
//   const extractUser = (obj) => obj?.user || obj?.User || obj?.Customer || {};
//   const sortNewestFirst = (a, b) =>
//     new Date(b.created_at || b.createdAt) -
//     new Date(a.created_at || a.createdAt);

//   /* ─── FETCH COMMENTS + REPLIES ─────────────────────── */
//   const fetchAll = useCallback(async () => {
//     if (!requestId) return;

//     try {
//       /* parent comments */
//       const { data: cRes } = await axios.get(
//         `${API_V2}/quotes/getallcomment/${requestId}`,
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );

//       const commentArr = (
//         Array.isArray(cRes.data) ? cRes.data : [cRes.data || []]
//       )
//         .filter(Boolean)
//         .sort(sortNewestFirst);

//       /* attach replies */
//       const withReplies = await Promise.all(
//         commentArr.map(async (cm) => {
//           try {
//             const { data: rRes } = await axios.get(
//               `${API_V2}/quotes/getreplycomment/${cm.id}`,
//               { headers: { Authorization: `Bearer ${accessToken}` } }
//             );
//             const repliesArr = (
//               Array.isArray(rRes.data) ? rRes.data : [rRes.data || []]
//             )
//               .filter(Boolean)
//               .sort(sortNewestFirst);
//             return { ...cm, replies: repliesArr };
//           } catch {
//             return { ...cm, replies: [] };
//           }
//         })
//       );

//       setComments(withReplies);
//     } catch {
//       /* silent fail on first load */
//     }
//   }, [API_V2, accessToken, requestId]);

//   useEffect(() => {
//     fetchAll();
//   }, [fetchAll]);

//   /* ─── LIKE / DISLIKE ───────────────────────────────── */
//   const handleReaction = async (id, type) => {
//     try {
//       await axios.post(
//         `${API_V2}/quotes/likedislike/${id}?reaction_type=${type}`,
//         null,
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );
//       toast.success(
//         type === "like"
//           ? "You liked this comment."
//           : "You disliked this comment."
//       );
//       await fetchAll(); // ✅ ADDED
//     } catch {
//       toast.error("Failed to react.");
//     }
//   };

//   /* ─── ADD REPLY ───────────────────────────────────── */
//   const handleAddReply = async (parentId) => {
//     const text = (replyDrafts[parentId] || "").trim();
//     if (!text || submittingIds[parentId]) return;
//     setSubmittingIds((prev) => ({ ...prev, [parentId]: true }));
//     try {
//       await axios.post(
//         `${API_V2}/quotes/reply/${parentId}`,
//         { reply: text },
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );
//       setReplyDrafts((p) => ({ ...p, [parentId]: "" }));
//       await fetchAll(); // ✅ ADDED
//       toast.success("Reply added.");
//       await fetchAll();
//     } catch {
//       toast.error("Failed to add reply.");
//     } finally {
//       setSubmittingIds((prev) => {
//         const updated = { ...prev };
//         delete updated[parentId];
//         return updated;
//       });
//     }
//   };

//   /* ─── EDIT REPLY ──────────────────────────────────── */
//   const saveEditReply = async () => {
//     if (!editingReplyText.trim()) return;
//     try {
//       await axios.put(
//         `${API_V2}/quotes/editreply/${editingReplyId}`,
//         { reply: editingReplyText.trim() },
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );
//       setEditingReplyId(null);
//       setEditingReplyText("");
//       toast.success("Reply updated.");
//       await fetchAll();
//     } catch {
//       toast.error("Failed to update reply.");
//     }
//   };

//   /* ─── DELETE COMMENT / REPLY ──────────────────────── */
//   const confirmDelete = async () => {
//     if (deleteTarget == null) return;

//     const isReply = comments.some((c) =>
//       c.replies.some((r) => r.id === deleteTarget)
//     );
//     const url = isReply
//       ? `${API_V2}/quotes/delete/${deleteTarget}`
//       : `${API_V2}/quotes/deletecomment/${deleteTarget}`;

//     try {
//       await axios.delete(url, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
//       setDeleteTarget(null);
//       toast.success("Deleted.");
//       setTimeout(fetchAll, 200);
//     } catch {
//       toast.error("Failed to delete.");
//     }
//   };

//   /* ─── REPORT COMMENT ─────────────────────────────── */
//   const openReport = (commentId) => {
//     setReportTarget(commentId);
//     setReasonType("");
//     setCustomReason("");
//     setReportOpen(true);
//   };
//   const submitReport = async () => {
//     if (!reasonType) return toast.error("Please select a reason.");
//     if (reasonType === "others" && !customReason.trim())
//       return toast.error("Please enter custom reason.");

//     const payload = {
//       reason_type: reasonType === "others" ? "others" : reasonType,
//       custom_reason: reasonType === "others" ? customReason.trim() : "",
//     };

//     setReportSubmitting(true);
//     try {
//       await axios.post(`${API_V2}/quotes/report/${reportTarget}`, payload, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
//       toast.success("Report submitted.");
//       setReportOpen(false);
//     } catch {
//       toast.error("Report has already sent");
//     } finally {
//       setReportSubmitting(false);
//     }
//   };

//   /* ─── RENDER ───────────────────────────────────────── */
//   return (
//     <div className="mt-5 border flex flex-col bg-gray-50 rounded-lg shadow-lg max-h-[600px]">
//       {/* Header */}
//       {/* <div className="flex-shrink-0 bg-white px-6 py-4 border-b">
//         <div className="flex justify-between items-center gap-4">
//           <h3 className="text-xl font-semibold text-gray-800">
//             Clarification Board
//           </h3>
//           <h2 className="text-sm text-gray-600">
//             No Spam, self-promotion or advertisement is permitted.
//           </h2>
//         </div>
//       </div> */}

//       {/* ───────── Header (responsive) ───────── */}
//       <div className="flex-shrink-0 bg-white px-3 sm:px-6 py-3 sm:py-4 border-b">
//         <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-4">
//           <h3 className="text-base sm:text-xl font-semibold text-gray-800">
//             Clarification Board
//           </h3>

//           <h2 className="text-xs sm:text-sm text-gray-600 text-left sm:text-right">
//             No Spam, self-promotion or advertisement is permitted.
//           </h2>
//         </div>
//       </div>

//       {/* Comment list */}
//       {/* ───────── Comment list (responsive) ───────── */}
//       <div className="flex-1 overflow-y-auto px-3 sm:px-4 py-3 sm:py-4 space-y-3 sm:space-y-4 bg-white">
//         {comments.length === 0 ? (
//           <p className="text-center text-gray-500 italic">
//             No comments from supplier.
//           </p>
//         ) : (
//           comments.map((c) => {
//             const cUser = extractUser(c);

//             return (
//               /* ── Comment row ── */
//               <div key={c.id} className="flex items-start gap-2 sm:gap-3">
//                 {/* avatar / initial */}
//                 {/* {cUser.profile_id ? (
//                   <img
//                     src={buildProfileUrl(cUser.id, cUser.profile_id)}
//                     alt={`${cUser.first_name} ${cUser.last_name}`}
//                     className="w-9 h-9 sm:w-10 sm:h-10 rounded-full object-cover flex-shrink-0"
//                   />
//                 ) : (
//                   <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-blue-400 text-white flex items-center justify-center font-medium flex-shrink-0">
//                     {cUser.first_name?.[0] || "S"}
//                   </div>
//                 )} */}
//                 <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-blue-400 text-white flex items-center justify-center font-medium flex-shrink-0">
//                   {cUser.first_name?.[0] || "S"}
//                 </div>

//                 {/* bubble + replies */}
//                 <div className="flex-1">
//                   {/* bubble */}
//                   <div className="bg-gray-100 rounded-xl px-3 sm:px-4 py-2">
//                     {/* header */}
//                     <div className="flex items-center justify-between">
//                       <span className="font-medium text-gray-800 text-sm sm:text-base">
//                         Anonymous
//                       </span>

//                       {/* reactions + report */}
//                       <div className="flex gap-6 text-xs sm:text-sm text-gray-500">
//                         <button
//                           className="flex flex-col items-center"
//                           onClick={() => handleReaction(c.id, "like")}
//                         >
//                           <IoThumbsUp className="w-5 h-5" />
//                           <span>{c.like}</span>
//                         </button>

//                         <button
//                           className="flex flex-col items-center"
//                           onClick={() => handleReaction(c.id, "dislike")}
//                         >
//                           <IoThumbsDown className="w-5 h-5" />
//                           <span>{c.dislike}</span>
//                         </button>

//                         <button
//                           className="flex items-center gap-1 hover:text-rose-600"
//                           onClick={() => openReport(c.id)}
//                           title="Report comment"
//                         >
//                           <IoFlag className="w-5 h-5" />
//                           <span>Report</span>
//                         </button>
//                       </div>
//                     </div>

//                     <p className="mt-1 text-gray-700 text-sm sm:text-base">
//                       {c.comment}
//                     </p>
//                   </div>

//                   {/* ── replies ── */}
//                   <div className="mt-3 pl-6 sm:pl-12 space-y-3">
//                     {c.replies.map((r) => {
//                       const rUser = extractUser(r);
//                       const role = r.reply_by_role?.toUpperCase();
//                       const isCustomerReply = role === "CUSTOMER";

//                       return (
//                         /* reply row */
//                         <div
//                           key={r.id}
//                           className="flex items-start gap-2 sm:gap-3"
//                         >
//                           {/* avatar */}
//                           {/* {rUser.profile_id ? (
//                             <img
//                               src={buildProfileUrl(rUser.id, rUser.profile_id)}
//                               alt={`${rUser.first_name} ${rUser.last_name}`}
//                               className="w-7 h-7 sm:w-8 sm:h-8 rounded-full object-cover flex-shrink-0"
//                             />
//                           ) : (
//                             <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gray-300 text-gray-700 flex items-center justify-center font-medium flex-shrink-0">
//                               {rUser.first_name?.[0] || "U"}
//                             </div>
//                           )} */}
//                           <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gray-300 text-gray-700 flex items-center justify-center font-medium flex-shrink-0">
//                             {rUser.first_name?.[0] || "U"}
//                           </div>

//                           {/* reply bubble */}
//                           <div className="flex-1 bg-gray-100 rounded-xl px-3 py-2">
//                             {/* header */}
//                             <div className="flex items-center justify-between">
//                               <span className="font-medium text-gray-800 text-xs sm:text-sm">
//                                 Anonymous
//                               </span>

//                               {isCustomerReply &&
//                                 (editingReplyId === r.id ? (
//                                   /* edit mode */
//                                   <div className="flex flex-col sm:flex-row gap-2 mt-1 sm:mt-0">
//                                     <input
//                                       className="flex-1 border rounded-md px-2 py-0.5 text-xs sm:text-sm focus:ring-2 focus:ring-green-500"
//                                       value={editingReplyText}
//                                       onChange={(e) =>
//                                         setEditingReplyText(e.target.value)
//                                       }
//                                     />
//                                     <div className="flex gap-2 self-end sm:self-auto">
//                                       <button
//                                         className="text-green-600 font-medium text-xs sm:text-sm"
//                                         onClick={saveEditReply}
//                                       >
//                                         Save
//                                       </button>
//                                       <button
//                                         className="text-gray-600 text-xs sm:text-sm"
//                                         onClick={() => {
//                                           setEditingReplyId(null);
//                                           setEditingReplyText("");
//                                         }}
//                                       >
//                                         Cancel
//                                       </button>
//                                     </div>
//                                   </div>
//                                 ) : (
//                                   /* action icons */
//                                   <div className="flex gap-2 text-gray-400">
//                                     <IoPencil
//                                       className="w-4 h-4 cursor-pointer hover:text-blue-600"
//                                       onClick={() => {
//                                         setEditingReplyId(r.id);
//                                         setEditingReplyText(r.reply);
//                                       }}
//                                     />
//                                     <IoTrashBin
//                                       className="w-4 h-4 cursor-pointer hover:text-red-600"
//                                       onClick={() => setDeleteTarget(r.id)}
//                                     />
//                                   </div>
//                                 ))}
//                             </div>

//                             {editingReplyId !== r.id && (
//                               <p className="mt-1 text-gray-700 text-xs sm:text-sm">
//                                 {r.reply}
//                               </p>
//                             )}
//                           </div>
//                         </div>
//                       );
//                     })}

//                     {/* reply input */}
//                     <form
//                       className="pl-6 sm:pl-12 pt-3 flex flex-col sm:flex-row gap-2"
//                       onSubmit={(e) => {
//                         e.preventDefault();
//                         handleAddReply(c.id);
//                       }}
//                     >
//                       <input
//                         className="flex-1 border rounded-md px-2 py-1 text-xs sm:text-sm focus:ring-2 focus:ring-blue-500"
//                         placeholder="Type your reply..."
//                         value={replyDrafts[c.id] || ""}
//                         onChange={(e) =>
//                           setReplyDrafts((p) => ({
//                             ...p,
//                             [c.id]: e.target.value,
//                           }))
//                         }
//                       />
//                       <div className="flex gap-2 self-end sm:self-auto">
//                         <button
//                           type="submit"
//                           className="bg-blue-600 text-white text-xs sm:text-sm px-3 py-1 rounded-md hover:bg-blue-700 disabled:opacity-50"
//                           disabled={!!submittingIds[c.id]}
//                         >
//                           Send
//                         </button>
//                         <button
//                           type="button"
//                           className="text-xs sm:text-sm text-gray-600"
//                           onClick={() =>
//                             setReplyDrafts((p) => ({ ...p, [c.id]: "" }))
//                           }
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     </form>
//                   </div>
//                 </div>
//               </div>
//             );
//           })
//         )}
//       </div>

//       {/* DELETE confirm */}
//       {deleteTarget != null && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 w-80">
//             <p className="text-center mb-4">Delete this item?</p>
//             <div className="flex justify-end space-x-4">
//               <button
//                 className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
//                 onClick={() => setDeleteTarget(null)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
//                 onClick={confirmDelete}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* REPORT modal */}
//       {reportOpen && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 w-96">
//             <h4 className="text-lg font-semibold mb-4">Report Comment</h4>

//             <label className="block text-sm mb-1">Reason</label>
//             <select
//               className="w-full border rounded-md px-2 py-1 mb-4"
//               value={reasonType}
//               onChange={(e) => setReasonType(e.target.value)}
//             >
//               <option value="">-- select reason --</option>
//               <option value="Scam ,Fraud or Spam">Scam ,Fraud or Spam</option>
//               <option value="Self Promotion or contact details shared">
//                 Self Promotion or contact details shared
//               </option>
//               <option value="others">Others</option>
//             </select>

//             {reasonType === "others" && (
//               <>
//                 <label className="block text-sm mb-1">Describe</label>
//                 <textarea
//                   className="w-full border rounded-md px-2 py-1 mb-4"
//                   rows="3"
//                   placeholder="Type your reason..."
//                   value={customReason}
//                   onChange={(e) => setCustomReason(e.target.value)}
//                 />
//               </>
//             )}

//             <div className="flex justify-end space-x-4">
//               <button
//                 className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
//                 onClick={() => setReportOpen(false)}
//                 disabled={reportSubmitting}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="px-4 py-2 bg-rose-600 text-white rounded-md hover:bg-rose-700 disabled:opacity-50"
//                 onClick={submitReport}
//                 disabled={reportSubmitting}
//               >
//                 {reportSubmitting ? "Submitting..." : "Submit"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default CustomerClarificationBoard;

// CustomerClarificationBoard.jsx
import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  IoPencil,
  IoTrashBin,
  IoThumbsUp,
  IoThumbsDown,
  IoFlag,
} from "react-icons/io5";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
// 🔽 update the path if your folder depth differs
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";

const CustomerClarificationBoard = ({ user, requestId }) => {
  /* ─── STATE ────────────────────────────────────────── */
  const [comments, setComments] = useState([]);
  const [replyDrafts, setReplyDrafts] = useState({});
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [editingReplyId, setEditingReplyId] = useState(null);
  const [editingReplyText, setEditingReplyText] = useState("");
  const [expandedComments, setExpandedComments] = useState({});
  const submittingRef = useRef({});
  const [submittingIds, setSubmittingIds] = useState({});

  /* REPORT modal */
  const [reportOpen, setReportOpen] = useState(false);
  const [reportTarget, setReportTarget] = useState(null);
  const [reasonType, setReasonType] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [reportSubmitting, setReportSubmitting] = useState(false);

  /* CONFIG / HELPERS */
  const API_V2 = process.env.REACT_APP_SERVER_URL_V2;
  const API_V1 = API_V2?.replace("/api/v2", "/api/v1");

  const dispatch = useDispatch();

  // 🔐 Always ensure fresh token before requests
  const ensureAuth = useCallback(async () => {
    await dispatch(refreshIfNeeded());
    const fresh = localStorage.getItem("accessToken");
    if (!fresh) throw new Error("No access token");
    return { headers: { Authorization: `Bearer ${fresh}` } };
  }, [dispatch]);

  const buildProfileUrl = (uid, pid) =>
    uid && pid ? `${API_V1}/photos/${uid}/images/${pid}` : null;

  const extractUser = (obj) => obj?.user || obj?.User || obj?.Customer || {};

  const sortNewestFirst = (a, b) =>
    new Date(b.created_at || b.createdAt) -
    new Date(a.created_at || a.createdAt);

  /* ─── FETCH COMMENTS + REPLIES ─────────────────────── */
  const fetchAll = useCallback(async () => {
    if (!requestId) return;

    try {
      const headers = await ensureAuth();

      // parent comments
      const { data: cRes } = await axios.get(
        `${API_V2}/quotes/getallcomment/${requestId}`,
        headers
      );

      const commentArr = (
        Array.isArray(cRes.data) ? cRes.data : [cRes.data || []]
      )
        .filter(Boolean)
        .sort(sortNewestFirst);

      // attach replies
      const withReplies = await Promise.all(
        commentArr.map(async (cm) => {
          try {
            const { data: rRes } = await axios.get(
              `${API_V2}/quotes/getreplycomment/${cm.id}`,
              headers
            );
            const repliesArr = (
              Array.isArray(rRes.data) ? rRes.data : [rRes.data || []]
            )
              .filter(Boolean)
              .sort(sortNewestFirst);
            return { ...cm, replies: repliesArr };
          } catch {
            return { ...cm, replies: [] };
          }
        })
      );

      setComments(withReplies);
    } catch {
      // silent on first load
    }
  }, [API_V2, ensureAuth, requestId]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  /* ─── LIKE / DISLIKE ───────────────────────────────── */
  const handleReaction = async (id, type) => {
    try {
      const headers = await ensureAuth();
      await axios.post(
        `${API_V2}/quotes/likedislike/${id}?reaction_type=${type}`,
        null,
        headers
      );
      toast.success(
        type === "like"
          ? "You liked this comment."
          : "You disliked this comment."
      );
      await fetchAll();
    } catch {
      toast.error("Failed to react.");
    }
  };

  /* ─── ADD REPLY ───────────────────────────────────── */
  const handleAddReply = async (parentId) => {
    const text = (replyDrafts[parentId] || "").trim();
    if (!text || submittingIds[parentId]) return;

    setSubmittingIds((prev) => ({ ...prev, [parentId]: true }));
    try {
      const headers = await ensureAuth();
      await axios.post(
        `${API_V2}/quotes/reply/${parentId}`,
        { reply: text },
        headers
      );
      setReplyDrafts((p) => ({ ...p, [parentId]: "" }));
      toast.success("Reply added.");
      await fetchAll();
    } catch {
      toast.error("Failed to add reply.");
    } finally {
      setSubmittingIds((prev) => {
        const updated = { ...prev };
        delete updated[parentId];
        return updated;
      });
    }
  };

  /* ─── EDIT REPLY ──────────────────────────────────── */
  const saveEditReply = async () => {
    if (!editingReplyText.trim()) return;
    try {
      const headers = await ensureAuth();
      await axios.put(
        `${API_V2}/quotes/editreply/${editingReplyId}`,
        { reply: editingReplyText.trim() },
        headers
      );
      setEditingReplyId(null);
      setEditingReplyText("");
      toast.success("Reply updated.");
      await fetchAll();
    } catch {
      toast.error("Failed to update reply.");
    }
  };

  /* ─── DELETE COMMENT / REPLY ──────────────────────── */
  const confirmDelete = async () => {
    if (deleteTarget == null) return;

    const isReply = comments.some((c) =>
      c.replies.some((r) => r.id === deleteTarget)
    );
    const url = isReply
      ? `${API_V2}/quotes/delete/${deleteTarget}`
      : `${API_V2}/quotes/deletecomment/${deleteTarget}`;

    try {
      const headers = await ensureAuth();
      await axios.delete(url, headers);
      setDeleteTarget(null);
      toast.success("Deleted.");
      await fetchAll();
    } catch {
      toast.error("Failed to delete.");
    }
  };

  /* ─── REPORT COMMENT ─────────────────────────────── */
  const openReport = (commentId) => {
    setReportTarget(commentId);
    setReasonType("");
    setCustomReason("");
    setReportOpen(true);
  };

  const submitReport = async () => {
    if (!reasonType) return toast.error("Please select a reason.");
    if (reasonType === "others" && !customReason.trim())
      return toast.error("Please enter custom reason.");

    const payload = {
      reason_type: reasonType === "others" ? "others" : reasonType,
      custom_reason: reasonType === "others" ? customReason.trim() : "",
    };

    setReportSubmitting(true);
    try {
      const headers = await ensureAuth();
      await axios.post(
        `${API_V2}/quotes/report/${reportTarget}`,
        payload,
        headers
      );
      toast.success("Report submitted.");
      setReportOpen(false);
    } catch {
      toast.error("Report has already sent");
    } finally {
      setReportSubmitting(false);
    }
  };

  /* ─── RENDER ───────────────────────────────────────── */
  return (
    <div className="mt-5 border flex flex-col bg-gray-50 rounded-lg shadow-lg max-h-[600px]">
      {/* ───────── Header (responsive) ───────── */}
      <div className="flex-shrink-0 bg-white px-3 sm:px-6 py-3 sm:py-4 border-b">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-4">
          <h3 className="text-base sm:text-xl font-semibold text-gray-800">
            Clarification Board
          </h3>
          <h2 className="text-xs sm:text-sm text-gray-600 text-left sm:text-right">
            No Spam, self-promotion or advertisement is permitted.
          </h2>
        </div>
      </div>

      {/* ───────── Comment list (responsive) ───────── */}
      <div className="flex-1 overflow-y-auto px-3 sm:px-4 py-3 sm:py-4 space-y-3 sm:space-y-4 bg-white">
        {comments.length === 0 ? (
          <p className="text-center text-gray-500 italic">
            No comments from supplier.
          </p>
        ) : (
          comments.map((c) => {
            const cUser = extractUser(c);

            return (
              <div key={c.id} className="flex items-start gap-2 sm:gap-3">
                {/* avatar */}
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-blue-400 text-white flex items-center justify-center font-medium flex-shrink-0">
                  {cUser.first_name?.[0] || "S"}
                </div>

                {/* bubble + replies */}
                <div className="flex-1">
                  {/* bubble */}
                  <div className="bg-gray-100 rounded-xl px-3 sm:px-4 py-2">
                    {/* header */}
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-gray-800 text-sm sm:text-base">
                        Anonymous
                      </span>

                      {/* reactions + report */}
                      <div className="flex gap-6 text-xs sm:text-sm text-gray-500">
                        <button
                          className="flex flex-col items-center"
                          onClick={() => handleReaction(c.id, "like")}
                        >
                          <IoThumbsUp className="w-5 h-5" />
                          <span>{c.like}</span>
                        </button>

                        <button
                          className="flex flex-col items-center"
                          onClick={() => handleReaction(c.id, "dislike")}
                        >
                          <IoThumbsDown className="w-5 h-5" />
                          <span>{c.dislike}</span>
                        </button>

                        <button
                          className="flex items-center gap-1 hover:text-rose-600"
                          onClick={() => openReport(c.id)}
                          title="Report comment"
                        >
                          <IoFlag className="w-5 h-5" />
                          <span>Report</span>
                        </button>
                      </div>
                    </div>

                    <p className="mt-1 text-gray-700 text-sm sm:text-base">
                      {c.comment}
                    </p>
                  </div>

                  {/* replies */}
                  <div className="mt-3 pl-6 sm:pl-12 space-y-3">
                    {c.replies.map((r) => {
                      const rUser = extractUser(r);
                      const role = r.reply_by_role?.toUpperCase();
                      const isCustomerReply = role === "CUSTOMER";

                      return (
                        <div
                          key={r.id}
                          className="flex items-start gap-2 sm:gap-3"
                        >
                          {/* avatar */}
                          <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gray-300 text-gray-700 flex items-center justify-center font-medium flex-shrink-0">
                            {rUser.first_name?.[0] || "U"}
                          </div>

                          {/* reply bubble */}
                          <div className="flex-1 bg-gray-100 rounded-xl px-3 py-2">
                            <div className="flex items-center justify-between">
                              <span className="font-medium text-gray-800 text-xs sm:text-sm">
                                Anonymous
                              </span>

                              {isCustomerReply &&
                                (editingReplyId === r.id ? (
                                  <div className="flex flex-col sm:flex-row gap-2 mt-1 sm:mt-0">
                                    <input
                                      className="flex-1 border rounded-md px-2 py-0.5 text-xs sm:text-sm focus:ring-2 focus:ring-green-500"
                                      value={editingReplyText}
                                      onChange={(e) =>
                                        setEditingReplyText(e.target.value)
                                      }
                                    />
                                    <div className="flex gap-2 self-end sm:self-auto">
                                      <button
                                        className="text-green-600 font-medium text-xs sm:text-sm"
                                        onClick={saveEditReply}
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="text-gray-600 text-xs sm:text-sm"
                                        onClick={() => {
                                          setEditingReplyId(null);
                                          setEditingReplyText("");
                                        }}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flex gap-2 text-gray-400">
                                    <IoPencil
                                      className="w-4 h-4 cursor-pointer hover:text-blue-600"
                                      onClick={() => {
                                        setEditingReplyId(r.id);
                                        setEditingReplyText(r.reply);
                                      }}
                                    />
                                    <IoTrashBin
                                      className="w-4 h-4 cursor-pointer hover:text-red-600"
                                      onClick={() => setDeleteTarget(r.id)}
                                    />
                                  </div>
                                ))}
                            </div>

                            {editingReplyId !== r.id && (
                              <p className="mt-1 text-gray-700 text-xs sm:text-sm">
                                {r.reply}
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    {/* reply input */}
                    <form
                      className="pl-6 sm:pl-12 pt-3 flex flex-col sm:flex-row gap-2"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleAddReply(c.id);
                      }}
                    >
                      <input
                        className="flex-1 border rounded-md px-2 py-1 text-xs sm:text-sm focus:ring-2 focus:ring-blue-500"
                        placeholder="Type your reply..."
                        value={replyDrafts[c.id] || ""}
                        onChange={(e) =>
                          setReplyDrafts((p) => ({
                            ...p,
                            [c.id]: e.target.value,
                          }))
                        }
                      />
                      <div className="flex gap-2 self-end sm:self-auto">
                        <button
                          type="submit"
                          className="bg-blue-600 text-white text-xs sm:text-sm px-3 py-1 rounded-md hover:bg-blue-700 disabled:opacity-50"
                          disabled={!!submittingIds[c.id]}
                        >
                          Send
                        </button>
                        <button
                          type="button"
                          className="text-xs sm:text-sm text-gray-600"
                          onClick={() =>
                            setReplyDrafts((p) => ({ ...p, [c.id]: "" }))
                          }
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* DELETE confirm */}
      {deleteTarget != null && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-80">
            <p className="text-center mb-4">Delete this item?</p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                onClick={() => setDeleteTarget(null)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* REPORT modal */}
      {reportOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h4 className="text-lg font-semibold mb-4">Report Comment</h4>

            <label className="block text-sm mb-1">Reason</label>
            <select
              className="w-full border rounded-md px-2 py-1 mb-4"
              value={reasonType}
              onChange={(e) => setReasonType(e.target.value)}
            >
              <option value="">-- select reason --</option>
              <option value="Scam ,Fraud or Spam">Scam ,Fraud or Spam</option>
              <option value="Self Promotion or contact details shared">
                Self Promotion or contact details shared
              </option>
              <option value="others">Others</option>
            </select>

            {reasonType === "others" && (
              <>
                <label className="block text-sm mb-1">Describe</label>
                <textarea
                  className="w-full border rounded-md px-2 py-1 mb-4"
                  rows={3}
                  placeholder="Type your reason..."
                  value={customReason}
                  onChange={(e) => setCustomReason(e.target.value)}
                />
              </>
            )}

            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                onClick={() => setReportOpen(false)}
                disabled={reportSubmitting}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-rose-600 text-white rounded-md hover:bg-rose-700 disabled:opacity-50"
                onClick={submitReport}
                disabled={reportSubmitting}
              >
                {reportSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default CustomerClarificationBoard;
